import { TenantGroupCodesSelect } from '../../components/TenantGroupCodesSelect/TenantGroupCodesSelect'
import { InventorySystemTypeSelect } from '../../components/InventorySystemTypeSelect/InventorySystemTypeSelect'
import type { IspRebuildFieldsProps } from './IspRebuildFields.types'

export function IspRebuildFields({
  state,
  update,
  availableCodes,
  isLoadingGroups,
}: IspRebuildFieldsProps) {
  return (
    <>
      <p className="rebuild-inventory-hint">
        Provide a tenant group, an inventory system type, or both. Both act as
        an AND filter over the inventory system profiles to rebuild.
      </p>
      <div className="create-form-table">
        <div className="create-form-row">
          <div className="create-form-label">Tenant Groups</div>
          <div className="create-form-input-cell">
            <TenantGroupCodesSelect
              availableCodes={availableCodes}
              selected={state.tenantGroupCodes}
              onChange={(tenantGroupCodes) => update({ tenantGroupCodes })}
              isLoading={isLoadingGroups}
            />
          </div>
        </div>
        <div className="create-form-row--last">
          <div className="create-form-label">Inventory System Type</div>
          <div className="create-form-input-cell">
            <InventorySystemTypeSelect
              value={state.inventorySystemType}
              onChange={(inventorySystemType) =>
                update({ inventorySystemType })
              }
            />
          </div>
        </div>
      </div>
    </>
  )
}
